// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LogIn: React.FC = () => {
    return <svg width="29px" height="22px" viewBox="0 0 29 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-438.000000, -295.000000)" fill="#424242">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(359.000000, 65.000000)">
                    <path d="M18.3560938,0.23109375 C16.3369688,0.23109375 14.3722188,0.7993125 12.673,1.874125 C11.0209063,2.91903125 9.68871875,4.39621875 8.819625,6.14346875 L10.4771563,6.96725 C11.9751875,3.95396875 14.9939063,2.08165625 18.3551875,2.08165625 C23.203625,2.08165625 27.147625,6.02565625 27.147625,10.8740938 C27.147625,15.7225313 23.203625,19.6665313 18.3551875,19.6665313 C14.993,19.6665313 11.9742813,17.7942188 10.4771563,14.7809375 L8.819625,15.6047188 C9.68871875,17.352875 11.0209063,18.8291563 12.673,19.8740625 C14.3722188,20.948875 16.3369688,21.5170938 18.3560938,21.5170938 C24.2249688,21.5170938 29,16.7420625 29,10.8731875 C29,5.0043125 24.2249688,0.22928125 18.3560938,0.22928125 L18.3560938,0.23109375 Z"></path>
                    <polygon points="13.99975 13.9227188 15.308375 15.2313438 19.6647188 10.875 15.308375 6.51865625 13.99975 7.82728125 16.1221875 9.94971875 -5.15143483e-15 9.94971875 -5.15143483e-15 11.8011875 16.1221875 11.8011875"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(LogIn);
